import './Block.css';
import { NavLink } from 'react-router-dom';
import languages from '/src/data/dropdown/languages';
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
function Block({type, name, description, created_at, language}) {

    var [date] = created_at.split('T');
    date = new Date(date).toDateString();
    date = date.split(' ');
    date.shift();
    var [m,d, y] = date;
    date = `${d} ${m}, ${y}`;

    const code = language.slug.toLowerCase();
    var Icon = languages.filter( (lang) => lang.value == code).shift();
    if(Icon) {
        Icon = Icon.text;
    }

    return (
        <>
        <NavLink to={urlWithRoutingCompany(`/${type}/${name}`)} className="block">
            <div className='main-container'>
                <div className='child-container'>
                    {Icon && Icon}
                    <div style={{ display : 'flex', justifyContent : 'space-between', width : '100%'}}>
                        <div className='child-container first-child'>
                            <div style={{textOverflow: "ellipsis", overflow: "hidden"}}>
                            {name}
                            </div>
                            </div>
                        <div className='child-container second-child' style={{textAlign : "center"}}>{date}</div>
                    </div>
                </div>
                <div className='child-container third-child' style={{minHeight : "44px"}}>
                    {description}
                </div>
            </div>
        </NavLink>
        </>
    )
}   

export default Block;